'use strict';
import { isiOs, isIE, isChrome, isFirefox, isSafari } from './plugins/browser-checks';

// global requires / imports
window.Cookies = require('js-cookie');

window.viewport = function() {
    let e = window,
        a = 'inner';

    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }

    return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
}

window.removeCookie = function (cookie) {
    Cookies.remove(cookie);
};

window.setCookie = function (cookie, value, expires) {
    Cookies.set(cookie, value, { expires: expires });
};

jQuery(() => {
    // global functionality goes here
    const $body = $('body'),
        $masthead = $('header.masthead');

    $body.addClass('jsenabled');

    if(isiOs()) $body.addClass('browser-ios');
    if(isIE()) $body.addClass('browser-ie');
    if(isChrome()) $body.addClass('browser-chrome');
    if(isFirefox()) $body.addClass('browser-firefox');
    if(isSafari()) $body.addClass('browser-safari');


    // prevent disabled buttons to execute default actions
    $('.btn--disabled').on('click', function(e) {
        e.preventDefault();
    });


    // disable hero-video with URL variable
    if (window.location.search.indexOf('no_video=1') >= 0) {
        $('.section__background-video').hide();
    }


    // load extra JS parts
    require('./modules/tooltips');
    require('./modules/gravity-forms');
    require('./modules/gtm-events');
    require('./modules/scroll-to-target');
    require('./modules/sliders');
    require('./modules/videos');
    require('./modules/anchors-missing-title');
    require('./modules/insert-icons');
    require('./modules/scroll-animations');
    require('./modules/smooth-scroll');
    require('./modules/sticky-masthead');
    require('./modules/menu');
    require('./modules/footer');
    require('./modules/expandable-items');
    require('./modules/dynamic-background-color');
    require('./modules/dbk-map');
    require('./modules/dialogs');
    require('./modules/fancybox');
    require('./modules/fareharbor');
});
